import { Component, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';

@Component({
  selector: 'rmt-segment-button',
  templateUrl: 'rmt-segment-button.html'
})
export class RmtSegmentButtonComponent {

  @Output() onSegmentChangedEvent = new EventEmitter<string>();
  @Input() toggleButtonList: Array<any>;
  @Input() activeToggleVal: number;
  @Input() underLineStyledTabs: boolean;

  constructor() {
  }

  onClickSegmentChanged(props) {
    this.activeToggleVal = props.value;
    this.onSegmentChangedEvent.emit(props.value)
  }

}



// WEBPACK FOOTER //
// ./src/components/rmt-segment-button/rmt-segment-button.ts